import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setMenuState } from '../../../reducers/wizard';

class NavigatorIndicator extends React.Component {
    render() {
        const { setMenuState, menuActive } = this.props;

        return (
            <span className="navigator-indicator no-select" onClick={() => setMenuState(!menuActive)}>
                <i className="material-icons">menu</i>
            </span>
        );
    }
}

NavigatorIndicator.defaultProps = {
    steps: undefined,
    activeStep: 0
};

NavigatorIndicator.propTypes = {
    steps: PropTypes.array,
    activeStep: PropTypes.number
};

const mapStateToProps = state => ({
    menuActive: state.wizard.menuActive
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            setMenuState: setMenuState
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(NavigatorIndicator);



// WEBPACK FOOTER //
// ./src/components/wizard/navigator/indicator.jsx